export const monthKeyToLabel = (monthValue) => {
  const raw = String(monthValue || '').slice(0, 7);
  if (!raw) return '-';
  const parsed = new Date(`${raw}-01T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return raw;
  return parsed.toLocaleString('en-US', { month: 'short', year: '2-digit' });
};

export const toRatingHistorySeries = (historyRows) => {
  if (!Array.isArray(historyRows)) return [];
  return historyRows.map((item) => ({
    month: monthKeyToLabel(item.month),
    stars: Number(item.stars || 0),
    score: Number(item.score || 0),
    pieces_completed: Number(item.pieces_completed || 0),
    qc_pass_rate: Number(item.qc_pass_rate || 0),
    attendance_rate: Number(item.attendance_rate || 0),
    on_time_rate: Number(item.on_time_rate || 0),
  }));
};

